$(document).ready(function () {
    console.log( 'JS Loaded' );
    document.querySelectorAll('.button-trans-w').forEach( button => {
      button.addEventListener('mouseenter', () => {
        button.children[0].children[0].style.setProperty('color', '#0D2E36', 'important');
        button.children[1].children[0].style.setProperty('color', '#0D2E36', 'important');
      });
      button.addEventListener('mouseleave', () => {
        button.children[0].children[0].style.setProperty('color', '#F9F9F9', 'important');
        button.children[1].children[0].style.setProperty('color', '#F9F9F9', 'important');
      });
    });
      //article touch
      const content = document.querySelector(".article-content");
      const tocContainer = document.getElementById("dynamic-toc");
      if (!content || !tocContainer) return;

      const headings = content.querySelectorAll("h2, h3, h4, h5, h6");
      if (headings.length === 0) {
        tocContainer.innerHTML = "<div>Description only Content</div>";
        return;
      }

      const headerSelectors = ".w-nav, header, .site-header, .navbar, .header, .nav";
      function getOffset() {
        let headerHeight = 0;
        document.querySelectorAll(headerSelectors).forEach(el => {
          const pos = getComputedStyle(el).position;
          if ((pos === "fixed" || pos === "sticky") && el.offsetHeight > headerHeight) {
            headerHeight = el.offsetHeight;
          }
        });
        return headerHeight + 16;
      }

      let OFFSET = getOffset();

      function applyScrollMarginTop() {
        OFFSET = getOffset();
        headings.forEach(h => {
          h.style.scrollMarginTop = OFFSET + "px";
        });
      }
      applyScrollMarginTop();
      window.addEventListener("resize", applyScrollMarginTop);

      let tocHTML = "";
      headings.forEach((heading, index) => {
        if (!heading.id) heading.id = "heading-" + index;
        const level = parseInt(heading.tagName.replace("H", ""), 10);
        const indent = (level - 2) * 15;
        tocHTML += `
          <div class="blog-post_content_link-wrapper" style="margin-left:${indent}px">
            <a href="#${heading.id}" class="blog-post_content_link w-inline-block">
              <div>${heading.innerText}</div>
            </a>
          </div>
        `;
      });
      tocContainer.innerHTML = tocHTML;

      tocContainer.querySelectorAll("a").forEach(link => {
        link.addEventListener("click", function (e) {
          e.preventDefault();
          const target = document.querySelector(this.getAttribute("href"));
          if (!target) return;

          OFFSET = getOffset();

          const y = target.getBoundingClientRect().top + window.pageYOffset - OFFSET;
          window.scrollTo({ top: y, behavior: "smooth" });
          history.pushState(null, "", this.getAttribute("href"));
        });
      });

      function onScroll() {
        let currentId = "";
        const trigger = OFFSET; 
        for (const heading of headings) {
          const rect = heading.getBoundingClientRect();
          if (rect.top - trigger <= 0 && rect.bottom - trigger > 0) {
            currentId = heading.id;
            break;
          }
        }
        tocContainer.querySelectorAll("a").forEach(link => {
          link.classList.toggle("w--current", link.getAttribute("href") === "#" + currentId);
        });
      }
      window.addEventListener("scroll", onScroll, { passive: true });
      onScroll();
    // Only enter above this line for custom JS
});
// if from Webflow and it doesn't need to be dom ready the below this line

 const initSlider = (identifier, config, breakpoint) => {
    let slider = null;
    if (breakpoint) {
      const runOnMatch = (media) => {
        if (media.matches && !slider) {
          config.init = false;
          slider = new Swiper(identifier, config);
          slider.init();
        }
        if (!media.matches && slider) {
          slider.destroy();
          slider = null;
        }
      };
      const media = window.matchMedia(
        `only screen and (${breakpoint >= 0 ? "min" : "max"}-width: ${
          breakpoint >= 0 ? breakpoint : breakpoint * -1
        }px)`
      );
      runOnMatch(media);
      window.addEventListener("resize", () => {
        runOnMatch(media);
      });
      media.addEventListener("change", runOnMatch);
    } else {
      slider = new Swiper(identifier, config);
    }
  };

gsap.registerPlugin(SplitText, ScrollTrigger);


    document.addEventListener('DOMContentLoaded', () => {
        //Swiper (Home Banner)
        initSlider('#is-home-header-background', {
          effect: 'fade',
          slidesPerView: 1,
          spaceBetween: 30,
          centeredSlides: true, 
          speed: 500,
          loop: true,
          autoplay: {
            delay: 8000, 
            disableOnInteraction: false, 
          },
          pagination: {
            el: '#pagination-home-header-background',
            bulletActiveClass: 'is-active',
            bulletClass: 'home_header-background_slider-dot',
            type: 'bullets',
            clickable: true,
          },
        });
      }); 

      document.addEventListener('DOMContentLoaded', () => {
         //Swiper (Home Product Slider)
    initSlider("#product-best-sellers", {
      slidesPerView: 'auto',
      spaceBetween: 12,
      speed: 1000,
      scrollbar: {
       	el: '#best-seller-scrollbar',
        draggable: true,
        dragClass: "component_swiper_drag",
        snapOnRelease: true
       },
       navigation: {
        nextEl: '#product-swiper-arrow-next',
        prevEl: '#product-swiper-arrow-prev',
        disabledClass: "is-disabled",
       },
    });
});

document.addEventListener('DOMContentLoaded', () => {
    //Swiper (home Featured Blogs)
    initSlider("#insights-updates", {
      slidesPerView: 'auto',
      spaceBetween: 12,
      speed: 1000,
    }, -991);
});

document.addEventListener('DOMContentLoaded', () => {
    //Swiper (home socials)
    initSlider("#is-socials", {
      slidesPerView: "auto",
      speed: 500,
      spaceBetween: 12,
      loop: true,
      freeMode: true,
   	});
});

document.addEventListener('DOMContentLoaded', () => {
  //Swiper (about timeline)
    initSlider("#is-timeline", {
      slidesPerView: 'auto',
      spaceBetween: 12,
    speed: 1000,
      scrollbar: {
       el: '#timeline-scroll-bar',
      draggable: true,
      dragClass: "component_swiper_drag",
      snapOnRelease: true
     },
     navigation: {
      nextEl: '#timeline-swiper-arrow-next',
      prevEl: '#timeline-swiper-arrow-prev',
      disabledClass: "is-disabled",
     },
    }, -991);
});


document.addEventListener('DOMContentLoaded', () => {
    //Swiper ( Testimonial Slider)
    initSlider("#is-testimonials", {
      slidesPerView: 'auto',
      spaceBetween: 12,
      speed: 1000,
      scrollbar: {
       	el: '#testimonials-scroll-bar',
        draggable: true,
        dragClass: "component_swiper_drag",
        snapOnRelease: true
       },
       navigation: {
        nextEl: '#testimonial-swiper-arrow-next',
        prevEl: '#testimonial-swiper-arrow-prev',
        disabledClass: "is-disabled",
       },
    });
});


document.addEventListener('DOMContentLoaded', () => {
    //Swiper (Membership Plan Section)
    initSlider("#is-pricing", {
      slidesPerView: 1,
      spaceBetween: 12,
      speed: 1000,
      scrollbar: {
       	el: '#pricing-scroll-bar',
        draggable: true,
        dragClass: "component_swiper_drag",
        snapOnRelease: true
       },
       navigation: {
        nextEl: '#pricing-swiper-arrow-next',
        prevEl: '#pricing-swiper-arrow-prev',
        disabledClass: "is-disabled",
       },
       breakpoints: {
        0: {
          slidesPerView: 1,
          spaceBetween: 12
        },
        480: {
          slidesPerView: 1.15,
          spaceBetween: 12
        },
        767: {
          slidesPerView: 1.25,
          spaceBetween: 12
        }
  		}
    }, -991);
});



(function () {
  const LEFT_SEL  = ".component_navbar_left .cart-count-bubble";
  const RIGHT_SEL = ".component_navbar_right .cart-count-bubble";

  const getCountFromBubble = (bubble) => {
    if (!bubble) return null;

    // Preferred: the visible aria-hidden number
    const visible = bubble.querySelector("span[aria-hidden='true']");
    if (visible && visible.textContent.trim() !== "") {
      return visible.textContent.trim();
    }

    // Fallback: parse number from the screen-reader text (e.g. "2 items")
    const sr = bubble.querySelector(".visually-hidden");
    if (sr) {
      const m = sr.textContent.match(/\d+/);
      if (m) return m[0];
    }
    return null;
  };

  const ensureRightVisibleSpan = (bubble) => {
    if (!bubble) return null;
    let span = bubble.querySelector("span[aria-hidden='true']");
    if (!span) {
      span = document.createElement("span");
      span.setAttribute("aria-hidden", "true");
      bubble.insertBefore(span, bubble.firstChild);
    }
    return span;
  };

  const sync = () => {
    const left  = document.querySelector(LEFT_SEL);
    const right = document.querySelector(RIGHT_SEL);
    if (!left || !right) return;

    const val = getCountFromBubble(left);
    const rightSpan = ensureRightVisibleSpan(right);
    if (val != null && rightSpan && rightSpan.textContent !== val) {
      rightSpan.textContent = val;
    }
  };

  const start = () => {
    const left = document.querySelector(LEFT_SEL);
    if (!left) return;

    // Observe changes within the left bubble (including span replacements)
    new MutationObserver(sync).observe(left, {
      childList: true,
      subtree: true,
      characterData: true
    });

    // If the left bubble itself ever gets replaced, watch its ancestor too
    (left.closest(".component_navbar_left") || document.body) &&
      new MutationObserver(sync).observe(
        left.closest(".component_navbar_left") || document.body,
        { childList: true, subtree: true }
      );

    sync();
  };

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", start);
  } else {
    start();
  }

  // Belt-and-suspenders: periodic sync in case a mutation is missed
  setInterval(sync, 300);
})();

  function removeUcButton(attempt = 1) {
      console.log(`Attempt ${attempt}: checking for Usercentrics button…`);

      const ucRoot = document.querySelector('#usercentrics-root');

      if (!ucRoot || !ucRoot.shadowRoot) {
          if (attempt < 20) {
              return setTimeout(() => removeUcButton(attempt + 1), 300);
          }
          console.warn("Failed to access Usercentrics shadow root after 20 attempts.");
          return;
      }

      const ucButton = ucRoot.shadowRoot.querySelector('button[data-testid="uc-privacy-button"]');

      if (ucButton) {
          ucButton.remove();
          console.log("%cUsercentrics privacy button removed!", "color: green; font-weight: bold;");
      } else {
          if (attempt < 20) {
              return setTimeout(() => removeUcButton(attempt + 1), 300);
          }
          console.warn("Privacy button NOT found after 20 attempts.");
      }
  }

  removeUcButton();
